export default interface StatusOrcamentoModel {
    name?: string;
    descricao?:string;
}

export const statusOrcamentoList:StatusOrcamentoModel[]  = [
    { name: "AGUARDANDO_PAGAMENTO_CONSERTO", descricao: "Aguardando pagamento do conserto"},
    { name: "AGUARDANDO_PENDENCIAS_CLIENTE", descricao: "Aguardando pendência cliente"},
    { name: "AGUARDANDO", descricao: "Aguardando fotos do cliente"},
    { name: "EM_EXECUCAO", descricao: "Em execução" },
    { name: "ERRO_INTEGRACAO_CILIA", descricao: "Erro de integração com o Cilia" },
    { name: "EXPIRADO", descricao: "Expirado" },
    { name: "FINALIZADO", descricao: "Finalizado" },
    { name: "RECUSADO", descricao: "Recusado" },
    { name: "RECUSADO_CLIENTE", descricao: "Recusado pelo cliente"},
    { name: "SOLICITADO", descricao: "Solicitado" },
    { name: "PENDENTE_PAGAMENTO", descricao: "Aguardando pagamento" },
]